<template>
    <div class=" offersbycatgory">
       
                        
            <b-container class="text-center px-0">
                <div>
                    <VueSlickCarousel v-bind="settings">
                        <b-col class="relative" v-for="(data,index) in bannerItems" :key="index">
							<b-link :href="data.url" >
                             <!-- <b-img class="b-img" src="../assets/home/shirt.jpg" fluid alt="Responsive image"></b-img> -->
							  <b-img-lazy v-bind="mainProps"  :src="$root.MEDIAPATH+'banners/category/offers/'+data.img" fluid ></b-img-lazy> 
							  
							  
                              <div class="absolute">
                                <p class="mb-2 desc" >{{data.title}}</p>
                                <b-button size="lg" rounded="top" class="offer-btn" >UPTO {{data.offer}}% OFF</b-button>
                              </div>
							 </b-link>
                        </b-col>
                        <!--<b-col class="relative">
                              <b-img class="b-img" src="../assets/home/shirt.jpg" fluid alt="Responsive image"></b-img>
                              <div class="absolute">
                                <p class="mb-2 desc" >shirts</p>
                                <b-button size="lg" rounded="top" class="offer-btn" >UPTO 40% OFF</b-button>
                              </div>
                        </b-col><b-col class="relative">
                              <b-img class="b-img" src="../assets/home/shirt.jpg" fluid alt="Responsive image"></b-img>
                              <div class="absolute">
                                <p class="mb-2 desc" >shirts</p>
                                <b-button size="lg" rounded="top" class="offer-btn" >UPTO 40% OFF</b-button>
                              </div>
                        </b-col><b-col class="relative">
                              <b-img class="b-img" src="../assets/home/shirt.jpg" fluid alt="Responsive image"></b-img>
                              <div class="absolute">
                                <p class="mb-2 desc" >shirts</p>
                                <b-button size="lg" rounded="top" class="offer-btn" >UPTO 40% OFF</b-button>
                              </div>
                        </b-col><b-col class="relative">
                              <b-img class="b-img" src="../assets/home/shirt.jpg" fluid alt="Responsive image"></b-img>
                              <div class="absolute">
                                <p class="mb-2 desc" >shirts</p>
                                <b-button size="lg" rounded="top" class="offer-btn " >UPTO 40% OFF</b-button>
                              </div>
                        </b-col> -->
                    </VueSlickCarousel>
                </div>
            </b-container>
        
    </div>
</template>
<script>

import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
    name: 'HeroCarousel',
    components: {VueSlickCarousel},
    data() {
        return {
			 mainProps: { class: 'm1', center: true,blankColor: '#fff',width:283,height:315},
            settings: {
                "arrows": true,
                "dotsClass": "slick-dots custom-dot-class",
                "edgeFriction": 0.35,
                "infinite": true,
                "autoplay": true,
                "speed": 500,
                "cssEase": "linear",
                "slidesToShow": 4,
                "slidesToScroll": 1,
                "responsive": [
							{
							  "breakpoint": 1024,
							  "settings": {
								"slidesToShow": 3,
								"slidesToScroll": 3,
								"infinite": true,
								"dots": true
							  }
							},
							{
							  "breakpoint": 600,
							  "settings": {
								"slidesToShow": 2,
								"slidesToScroll": 2,
								"initialSlide": 2
							  }
							},
							{
							  "breakpoint": 480,
							  "settings": {
								"slidesToShow": 1,
								"slidesToScroll": 1
							  }
							}
						  ]
            },
			bannerItems:[		 
			 {img:"Dresses.jpg",title:"Dresses",url:"/women-indian-wear",offer:'66'},
			 {img:"Kurti&Kurtas.jpg",title:"Kurti & Kurtas",url:"/kurtas-suits",offer:'58'},
			 {img:"T-Shirts.jpg",title:"T-Shirts",url:"/men-casual-shirts",offer:'76'},
			 {img:"Shirts.jpg",title:"Shirts",url:"/men-casual-shirts",offer:'30'},
			 {img:"Organic-Products.jpg",title:"Organic Products",url:"/organic",offer:'38'},
			 {img:"Cosmetic.jpg",title:"Cosmetics",url:"/cosmetics",offer:'48'},
			 {img:"SkinCare.jpg",title:"Skin Care",url:"/skin-care",offer:'38'},
			 {img:"MenShoes.jpg",title:"Men Shoes",url:"/men-footwear",offer:'74'},
			 {img:"WomenShoes.jpg",title:"Women Shoes",url:"/womens-footwear",offer:'10'},
			 {img:"Accessories.jpg",title:"Accessories",url:"/women-accessories",offer:'50'}
			 ],
        }
    },
}
</script>
<style  lang="scss">
.offersbycatgory{
    .relative {
        position:relative;
    }
    .absolute {
        position: absolute;
        bottom: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        left: 0;
        justify-content: center;
        overflow: hidden;
    }
    .offer-btn {
		width:85%;
        background: #f2f2f2;
        border-radius: 0 !important;
		border:0px;
        border-radius: 1rem 1rem 0rem 0rem !important;
        border-bottom-color: transparent !important;
        box-shadow: 0px 3px 55px rgba(0,0,0,0.5);
        color: black;
		&:hover {
			  background-color: #7954A1;
			  color:#fff;
			}
    }
	  
    .desc  {
        color: white;
        z-index: 0;
    }
		.slick{
		&-prev {
		  /*left: 3% !important;*/
		  top: 45% !important;
		 
			width: 25px;
			height: 25px;
			background-color: #FFF;
			box-shadow: #bbb 0px 0px 6px;
			border-radius: 100px;
			
		  &:before{ 					
				content: 'prev'; 
				font-family: swiper-icons;
				color: #683581;
				font-size: 15px;
				font-weight: 700;
			}
			
		  
		}
		&-next {
		 /* right: 3% !important;*/
			top: 45% !important;
			
		  	width: 25px;
			height: 25px;
			background-color: #FFF;
			box-shadow: #bbb 0px 0px 6px;
			border-radius: 100px;

			&:before{ 	
					content: 'next'; 
					font-family: swiper-icons;
					color: #683581;
					font-size: 15px;
					font-weight: 700;
				}
			
		} 
	
	}
	
	
	}
</style>